import { all, call, put, takeLatest } from 'redux-saga/effects';
import { api } from 'services';
import {
  history,
  LOADING,
  ASYNC_CREATE_ACTION,
  ASYNC_EDIT_ACTION,
  ASYNC_CHANGE_STATUS_ACTION,
  ASYNC_EDIT_ACTION_CREATIVE,
  ASYNC_CREATE_COMPROVATION,
  ASYNC_COMPROVATION_APPROVAL
} from 'store';

function* createAction({ payload }) {
  yield put({ type: LOADING, payload: true });

  try {
    yield call(api.post, 'actions', payload);

    if (payload.has('marketing_plan_id'))
      yield call(
        history.push,
        `/marketing-plans/edit/${payload.get('marketing_plan_id')}`
      );
    else yield call(history.push, '/actions');
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* editAction({ payload }) {
  yield put({ type: LOADING, payload: true });

  try {
    yield payload.append('_method', 'PUT');
    yield call(api.post, `actions/${payload.get('id')}`, payload);
    yield call(history.push, '/actions');
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* changeStatusAction({ payload }) {
  yield put({ type: LOADING, payload: true });

  try {
    yield call(api.post, 'actions/approve', payload);
    yield call(history.push, '/actions');
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* editActionCreative({ payload }) {
  yield put({ type: LOADING, payload: true });

  try {
    yield payload.append('_method', 'PUT');
    yield call(api.post, `action-comprovations/${payload.get('id')}`, payload);
    yield call(
      history.push,
      `/creative/show/${payload.get('action_task_item_id')}`
    );
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* saveComprovationCreative({ payload }) {
  try {
    yield call(api.post, 'action-comprovations', payload);
    yield call(history.push, '/creative');
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

function* comprovationApproval({ payload }) {
  try {
    yield payload.append('_method', 'PUT');
    yield call(api.post, `action-comprovations/${payload.get('id')}`, payload);
    yield call(
      history.push,
      `/actions/edit/${payload.get('action_id')}`,
      payload
    );
  } catch (error) {
  } finally {
    yield put({ type: LOADING, payload: false });
  }
}

export default function* root() {
  yield all([
    takeLatest(ASYNC_CREATE_ACTION, createAction),
    takeLatest(ASYNC_EDIT_ACTION, editAction),
    takeLatest(ASYNC_CHANGE_STATUS_ACTION, changeStatusAction),
    takeLatest(ASYNC_EDIT_ACTION_CREATIVE, editActionCreative),
    takeLatest(ASYNC_CREATE_COMPROVATION, saveComprovationCreative),
    takeLatest(ASYNC_COMPROVATION_APPROVAL, comprovationApproval)
  ]);
}
